var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTempoTotal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V12L12.7 14.9L13.5 13.7L9.5 11.3V6H8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 10C15.97 10.33 16 10.66 16 11C16 14.9 12.9 18 9 18C5.1 18 2 14.9 2 11C2 7.1 5.1 4 9 4C9.7 4 10.37 4.1 11 4.29V2.23C10.36 2.08 9.69 2 9 2C4 2 0 6 0 11C0 16 4 20 9 20C14 20 18 16 18 11C18 10.66 17.98 10.33 17.94 10H15.92Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V0H16V3H13V5H16V8H18V5H21V3H18Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTempoTotal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tempoTotal.073d02d2.svg";
export { ForwardRef as ReactComponent };